import { render, staticRenderFns } from "./MemberApplicationBankDetails.vue?vue&type=template&id=4c1d2caa"
import script from "./MemberApplicationBankDetails.vue?vue&type=script&lang=js"
export * from "./MemberApplicationBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports